import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Nullable } from '../../types/general';
import { EventCategoryValues, VIEWS } from '../../types/tracking';
import { RootState } from '../store';

export interface Context {
  eventCategory?: Nullable<EventCategoryValues>;
  view?: Nullable<VIEWS>;
}

const initialState: Context = {
  eventCategory: null,
  view: null,
};

const contextSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    setContext: (state, action: PayloadAction<Context>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const contextSelector = (state: RootState) => state.context;
export const { setContext } = contextSlice.actions;
export default contextSlice.reducer;
